// Package Imports
import React from "react";

// Local Imports
import { BodyOne } from "../typography";

type ResendSMSOTPBlockProps = {
  tailwindProps?: string,
  area?: string | null
}

const ResendSMSOTPBlock = ({ tailwindProps="" }: ResendSMSOTPBlockProps) => {
  return (
    <div className={`mt-8 ${tailwindProps}`}>
      <BodyOne className="text-center">
        If you are not receiving the SMS OTP code, please try again
        <a
          href="#"
          onClick={() => window.location.href = "login/sso-app/reset"}
          className="text-sm text-tripplo-200 text-bold font-poppins text-right m-0  pt-4 cursor-pointer"
        > here</a>
      </BodyOne>
    </div>
  )
}

export default ResendSMSOTPBlock
